import registerSearch from "./mf-search";
import registerFavourite from "./frontpage-favourite";
import registerTagList from "./mf-taglist";
import registerCollege from "./mf-college";
import registerTrack from "./mf-track";
import registerCollegeMatch from "./mf-colleagematch";
import registerExplore from "./mf-explore";
import registerMFIcon from "./mf-icon";
import registerButtonModal from "./mf-button-modal";
import registerLatest from "./mf-latest";
import registerFacebook from "./facebook";
import registerTwitter from "./mf-twitter";

import registerMyFeeds from "./mf-myfeed";
import registerYoutube from "./mf-youtube";

import { defaultStyles } from "./defaultStyle";

import {
  getWidget,
  registerDefaultWidgets,
  registerIcon,
  registerWidgetStyle,
  registerWidgetStyleOption,
  setDMEditorConfig,
} from "dmeditor";
import { registerServerSideLoad } from "dmeditor/core/ssr";
import { styleConfig } from "./styleConfig";

export const dmeditorInit = () => {
  registerDefaultWidgets();

  registerSearch();
  registerFacebook();
  registerTrack();
  registerFavourite();
  registerTagList();
  registerCollege();
  registerMFIcon();
  registerCollegeMatch();
  registerExplore();
  registerButtonModal();
  registerLatest();
  registerMyFeeds();
  registerTwitter();
  registerYoutube();

  registerIcon({
    name: "matchfit",
    component: () => <img width="20px" src="/logo.png" />,
  });

  for (const widget of Object.keys(defaultStyles)) {
    registerWidgetStyleOption(widget, [
      {
        identifier: "_default",
        name: "Default",
        ...defaultStyles[widget],
      },
    ]);
  }

  registerWidgetStyleOption("button", [
    {
      identifier: "primary",
      name: "Primary",
      cssClasses: {
        button:
          "bg-[#6e23e7] text-white rounded-md flex items-center font-medium text-sm md:text-base px-10 py-2",
      },
      cssStyle: "",
    },
  ]);

  registerWidgetStyle("heading", {
    identifier: "size",
    name: "Size",
    options: [
      {
        identifier: "block-title",
        name: "Block title",
        cssClasses: {
          root: "",
          h1: "mb-5 text-4xl md:text-5xl font-medium",
          h2: "mb-4 text-3xl md:text-4xl font-medium",
          h3: "mb-2 text-2xl md:text-3xl font-medium",
          h4: "mb-2 text-2xl font-medium",
        },
        cssStyle: ``,
      },
    ],
  });

  registerWidgetStyleOption("layout-3columns", [
    {
      identifier: "wide-space",
      name: "Wide space",
      cssClasses: {},
      cssStyle: `
      & >div{
        grid-gap: 10px;
      }
      `,
    },
  ]);

  registerWidgetStyle("heading", {
    identifier: "color",
    name: "Color",
    options: [
      {
        identifier: "theme",
        name: "Theme",
        cssClasses: {
          h2: "text-accent",
        },
        cssStyle: ``,
      },
    ],
  });

  registerWidgetStyleOption("heading", [
    {
      identifier: "block-text-search",
      name: "Block text search",
      cssClasses: {
        h2: "md:text-center text-black text-2xl lg:text-4xl font-medium py-4 md:py-8",
        root: "w-9/12 mx-auto",
      },
      cssStyle: ``,
    },
    {
      identifier: "searchbox-heading",
      name: "Heading in search box",
      cssClasses: {
        h3: "text-lg relative z-20",
        h1: "text-6xl font-bold relative z-20",
      },
      cssStyle: ``,
    },
  ]);

  ["list", "layout-2columns"].forEach((item) => {
    registerWidgetStyle(item, {
      identifier: "layout",
      name: "Layout",
      options: [
        {
          identifier: "center",
          name: "Center",
          cssClasses: {
            root: "layout-center",
          },
          cssStyle: ``,
        },
      ],
    });
  });

  ["layout-2columns", "list"].forEach((item) => {
    registerWidgetStyle(item, {
      identifier: "background",
      name: "Background",
      options: [
        {
          identifier: "blue1",
          name: "Blue 1",
          cssClasses: {
            root: "angled-line-up relative overflow-hidden fullbleed justify-center bg-[#002447] text-white",
          },
          cssStyle: ``,
        },
        {
          identifier: "blue2",
          name: "Blue 2",
          cssClasses: {
            root: "angled-line relative overflow-hidden fullbleed justify-center bg-[#002447] text-white",
          },
          cssStyle: `

      `,
        },
        {
          identifier: "blue3",
          name: "Blue 3",
          cssClasses: {
            root: "angled-line-3 h-full bg-blue-700 text-white",
          },
          cssStyle: `;
          padding-top: 50px;
        `,
        },
      ],
    });
  });

  setDMEditorConfig({
    general: {
      projectStyles: {
        default: `

            .dme-blocktype-frontpage-favourite .slick-arrow::before{
              content:'';
            }

            img{
              max-width: 100%;
            }                       

            .kenburns-top {
                animation: kenburns-top 120s infinite linear;
              }

              @keyframes kenburns-top {
                0% {
                    transform: translate(0, 0) skewX(2deg) skewY(-2deg) rotateY(30deg) translateZ(0px) scale(1.1);
                    transform-origin: top;
                  }
                
                25% {
                    transform: translate(-20%, -5%) skewX(2deg) skewY(-2deg) rotateY(30deg) translateZ(0px) scale(1.1);
                    transform-origin: top;
                  }

                50% {
                  transform: translate(0, 0) skewX(2deg) skewY(-2deg) rotateY(30deg) translateZ(0px) scale(1.1);
                  transform-origin: top;
                }

                75% {
                  transform: translate(20%, 5%) skewX(2deg) skewY(-2deg) rotateY(30deg) translateZ(0px) scale(1.1);
                  transform-origin: top;
                }

                100% {
                    transform: translate(0, 0) skewX(2deg) skewY(-2deg) rotateY(30deg) translateZ(0px) scale(1.1);
                    transform-origin: top;
                  }
              }
      `,
      },
      imagePath: (path, size) => {
        if (!path) {
          return path;
        }
        if (path.startsWith("http://") || path.startsWith("https://")) {
          return path;
        }
        if (size === "thumbnail") {
          return "https://dev2.matchfit.com/var/images/thumbnail/" + path;
        }
        return "https://dev2.matchfit.com/var/" + path;
      },
      // @ts-ignore
      themes: [
        {
          identifier: "red",
          name: "Red",
          cssStyle: `
        --project-main-color: red;
        --project-main-bg-color: #fbadad;
    
        /*background: var(--project-main-bg-color);  */
    
        /*todo: use css variable*/
        
      `,
        },
        {
          identifier: "blue",
          name: "Blue",
          cssStyle: `
        --project-main-color: blue;
        --project-main-bg-color: #e0e0ff;
        /*background: var(--project-main-bg-color);  */
      `,
        },
      ],
    },
    editor: {
      ui: {},
      zIndex: 500,
      defaultStyle: {
        heading: { _: "_default" },
        tabs: { _: "_default" },
        table: { _: "_default" },
        gallery: { _: "_default" },
        carousel: { _: "_default" },
      },
      configStyleSettings: styleConfig,
    },
  });
};
